var vcodeType = 2;
var phone = "";
var realName = "";
var vcode = "";
var messageType = "";
var certNo = "";
var codeToken = "";
var isCountDown = false; //是否允许发送短信
var isVoiceCountDown = false; // 语音验证码是否开始倒计时
var isGetCode = true;
var timerId;
var flag = false; // 记录是否需要身份认证
var workFlowKey = getUUID();
var workFlowId = '65562e8964684a6e9d08f386b62c99a3';

// 滑块相关字段
var isChange = false;//是否点击重新发送
var deviceId = 'shebeihaoshipc';

function getvcode(type) {

    if (type === 'SMS') {
        if (isCountDown) {
            return;
        } else {
            isGetCode = false;
        }
    }

    if (type === 'VOICE') {
        if (isVoiceCountDown) {
            return;
        } else {
            isGetCode = false;
        }
    }

    if (!checkRequired2('phone', '手机号不能为空') || !checkMoblie2('phone', '请输入正确的手机号')) {
        return;
    }

    messageType = type;

    phone = getValue('phone');

    //验证码接口
    sliderUrl();

}
// 调用滑块验证码
function sliderUrl() {
    toApi_toAcCg("S092023", {
        workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId
    },
        function (data) {
            $('#img_sldler').attr('src', data.backgroundImage);
            $('#block-slider').attr('src', data.sliderImage);
            $('#slider_box').css('display', 'block');
            $('#yzm').val('');
            $('#pasd1').val('');
            $('#pasd2').val('');
            // $('#vcode').addClass('none');
            // $('#vcode1').removeClass('none');
            tokenSlider = data.token;

        }, "login", "",
        function (data) {
            console.log(data);
        });
}
// 验证滑块验证码
function sliderVcode(dragScale) {
    console.log('vbvbvb',$.trim($('#phone').val()))
    toApi_toAcCg("S092024", {
        ratio: String(dragScale),
        token: tokenSlider,
        deviceId: deviceId,
        codeType: '2',
        teleno: RSAUtil_older($.trim($('#phone').val())),
        messageType: messageType,
        isFindPwd: true,
        workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId
    },
        function (data) {
            $('#slider_box').css('display', 'none');
            setTimeout(function () {
                block.style.left = '16px';
                moveBlock.style.left = '16px';
                p2.style.width = '16px';
            }, 1000)
            isFlage = false;
            if (data.state == '1') {
                alertMsg(data.respMsg)
            } else {
                timerId = window.clearInterval(timerId);
                countDown();
            }
        }, "login", "",

        function (data) {
            isFlage = false;
            if (data.respMsg) {
                alertMsg(data.respMsg)
            }

        });
}

// 关闭滑块验证码
function closeHandle() {
    $('#slider_box').css('display', 'none');
}
// 刷新滑块验证码
function refrehSlider() {
    block.style.left = '16px';
    moveBlock.style.left = '16px';
    sliderUrl();
}
// 展示手机号不可用？tips提示弹框
function showPhoneTips() {
    $('#phone-showTips').css('visibility', 'visible');
}
function closePhoneTips() {
    $('#phone-showTips').css('visibility', 'hidden');
}
/**
 * 验证码倒计时
 */
function countDown() {
    isCountDown = true;

    var msgBtn = $('#msgBtn');
    msgBtn.css('color', '#999999');
    msgBtn.removeClass("mouse");
    msgBtn.html('120秒后重发');
    var k = 119;
    timerId = window.setInterval(function () {
        if (k > 0) {
            $("#msgBtn").html(k + "秒后重发");
        } else {
            timerId = window.clearInterval(timerId);
            isCountDown = false;
            isGetCode = true;
            msgBtn.html("重新获取");
            msgBtn.css('color', '#58a3ff');
            msgBtn.addClass("mouse");
        }
        k--;

        // 展示语音验证码
        if (k == 114) {
            $('#voiceMsg').show();
        }
    }, 1000);
}

/**
 * 语音验证码倒计时
 */
function voiceCountDown() {
    isVoiceCountDown = true;

    $("#voiceMsg").html("请注意接听电话(120s)");
    $("#voiceMsg").css("color", "#999999");
    $("#voiceMsg").css("right", "-140px");
    var t = 119;
    var timerId = window.setInterval(function () {
        if (t > 0) {
            $("#voiceMsg").html("请注意接听电话(" + t + "s)");
        } else {
            timerId = window.clearInterval(timerId);
            isVoiceCountDown = false;
            isGetCode = true;
            $("#voiceMsg").html('收不到验证码？试试<span style="color:#00a7fb;cursor: pointer;" onClick="getvcode(\'' + 'VOICE' + '\')">语音验证码</span>');
            $("#voiceMsg").css("right", "-205px");
        }
        t--;
    }, 1000);
}

// 已废弃
function getVcodeSure(type) {
    var imgCode = getValue('imgCodeText');

    var params = {
        phone: phone,
        codeType: vcodeType,
        messageType: type,
        workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId,
        reqFlag: '0'
    };

    toApi_toAcCg('S111141', params, function (data) {
        messageType = type;
        if (type == 'SMS') {
            alertMsg('短信验证码发送成功');
            countDown();
        } else {
            alertMsg('语音验证码发送成功');
            voiceCountDown();
        }

        $('.tipMsgCover1').remove();
        codeToken = data.codeToken;
    }, "forget-loginpwd", "", function (data) {
        var sessionId = localStorage.sessionId;
        if (isNull(sessionId)) {
            sessionId = timeStampFun() + 'abc';
        }
        $('#registerImgcode').attr('src', baseGatewayURL + 'S092007?date=' + timeStampFun() + '&sessionId=' + sessionId);
        $(".lh151").css("display", "block");
    });
}

// 已废弃
function getVcodeDown(type) {

    if (type == 'SMS') {
        isCountDown = false;
        isGetCode = true;
    } else {
        isVoiceCountDown = false;
        isGetCode = true;
    }
    $('.tipMsgCover1').remove();
}

/*验证码重新获取*/
// 已废弃
function showPicReg() {
    //获取动态码
    var sessionId = localStorage.sessionId;
    if (isNull(sessionId)) {
        sessionId = timeStampFun() + 'abc';
    }
    $('#registerImgcode').attr('src', baseGatewayURL + 'S092007?date=' + timeStampFun() + '&sessionId=' + sessionId);
}

function goback_step1() {
    $('#step2').addClass('none');
    $('#step1').removeClass('none');
}

function checkVcode() {
    vcode = getValue('vcode');
    phone = getValue("phone");

    // $('#step1').addClass('none');
    // $('#step2').removeClass('none');

    // $('#step1').addClass('none');
    // $('#step3').removeClass('none');

    if (checkRequired2('phone', '手机号不能为空') && checkRequired2('vcode', '验证码不能为空')) {

    } else {
        return;
    }

    if (isGetCode) {
        alertMsg('请先获取验证码');
        return;
    }
    toApi_toAcCg('S111141', {
        codeType: '2', phone: phone, vcode: vcode, messageType: messageType, reqFlag: '1', source: '1', workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId
    }, function (data) {
        if (data.respCode == 'E101003') {
            alertMsg(data.respMsg);
        } else {
            timerId = window.clearInterval(timerId);
            isCountDown = false; //是否允许发送短信
            isVoiceCountDown = false;
            isGetCode = true;
            $("#msgBtn").text("获取验证码");
            if (data.jsonData) {
                flag = false;
                $('#step1').addClass('none');
                $('#step2').removeClass('none');
            } else {
                flag = true;
                $('#step1').addClass('none');
                $('#step3').removeClass('none');
            }
        }
        // $('#step3').removeClass('none');
    }, "forget-loginpwd", "");
}

function goback_step2() {
    if (flag) {
        $('#step3').addClass('none');
        $('#step1').removeClass('none');
    } else {
        $('#step3').addClass('none');
        $('#step2').removeClass('none');
    }

}

function checkRealName() {
    realName = getValue('realName');
    certNo = getValue('certNo').toUpperCase();
    $("#certNo").val(certNo);

    if (!checkRequired2('realName', '真实姓名不能为空') || !checkRequired2('certNo', '证件号码不能为空')) {
        return;
    }
    var data = {
        workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId
    };
    data.custName = encodeURI(realName);
    data.idType = $('#certType').val();
    data.idCode = certNo;
    data.teleno = phone;
    toApi_toAcCg('S111161', data, function (data) {
        // toApi('checkUserInfo.tml?teleno=' + phone + '&realName=' + encodeURI(realName) + '&certNo=' + certNo + '&certType=10', function(data) {
        if (data.jsonData.result) {
            $('#step2').addClass('none');
            $('#step3').removeClass('none');
        } else {
            alert("身份验证信息不通过,请重新输入");
        }
    }, "forget-loginpwd", "", function (data) {
        alert("身份验证信息不通过,请重新输入");
    });
}

function goback_step3() {
    $('#step4').addClass('none');
    $('#step3').removeClass('none');
}

// function resetLoginPwd() {
//     var e = getValue("newLoginPwd");
//     var o = getValue("renewLoginPwd");
//     if (checkRequired2("newLoginPwd", "新登录密码不能为空") && checkRequired2("renewLoginPwd", "重复新登录密码不能为空")) {
//         if ($("#newLoginPwd").val().length < 8) {
//             $('#e_newLoginPwd').removeClass('none');
//             $('#e_newLoginPwd').html('<i class="ic-error"></i>' + '登录密码不合规范，请重新输入');
//             return;
//         }
//         if (checkPassword3("newLoginPwd", "新登录密码过于简单")) {
//             if (e != o)
//                 return void alert("两次密码输入不一致!");
//             e = RSAUtil(e),
//                 o = RSAUtil(o),
//                 toApi("resetloginpwd.tml?phone=" + phone + "&vcode=" + vcode + "&newlpw=" + e + "&codeToken=" + codeToken + "&idtfno=" + certNo + "&custna=" + encodeURI(realName), function (e) {
//                     $("#step3").addClass("none"),
//                         $("#step4").removeClass("none")
//                 }, "forget-loginpwd", "")
//         }
//     }
// }

function resetLoginPwd() {
    var newLoginPwd = getValue('newLoginPwd');
    var renewLoginPwd = getValue('renewLoginPwd');


    console.log(checkRequired2('newLoginPwd', '新登录密码不能为空'), checkRequired2('renewLoginPwd', '确认登录密码不能为空'));
    if (checkRequired2('newLoginPwd', '新登录密码不能为空') && checkRequired2('renewLoginPwd', '确认登录密码不能为空')) {
        if ($("#newLoginPwd").val().length < 8) {
            $('#e_newLoginPwd').removeClass('none');
            $('#e_newLoginPwd').html('<i class="ic-error"></i>' + '登录密码不合规范，请重新输入');
            return;
        }
        if (!checkPassword3('newLoginPwd', '新登录密码过于简单')) {
            return;
        }
    } else {
        return;
    }
    if (newLoginPwd != renewLoginPwd) {
        alert('两次密码输入不一致!');
        return;
    }

    // newLoginPwd = RSAUtil(newLoginPwd);
    // renewLoginPwd = RSAUtil(renewLoginPwd);

    var data = {
        workFlowKey: workFlowKey + '|' + phone,
        workFlowId: workFlowId
    };
    data.pwd = RSAUtil(newLoginPwd);
    data.verifyPwd = RSAUtil(renewLoginPwd);
    data.teleno = phone;
    toApi_toAcCg('S092039', data, function (res) {
        console.log(res)
        if (res.state != '0' && res.respMsg) {
            alertMsg(res.respMsg)
        } else {
            $('#step3').addClass('none');
            $('#step4').removeClass('none');
        }

    });

    //调用修改密码接口
    // toApi_toAcCg('S092058', {}, function (req) {
    //     var publicKey = req.jsonData.pcLoginRsaPubKey;

    // });
    /*toApi('resetloginpwd.tml?phone=' + phone + '&vcode=' + vcode + '&newlpw=' + newLoginPwd + '&codeToken=' + codeToken + '&idtfno=' + certNo + '&custna=' + encodeURI(realName), function(data) {
        $('#step3').addClass('none');
        $('#step4').removeClass('none');

    }, "forget-loginpwd", "");*/
}

function isHide() {
    var input = document.getElementById("newLoginPwd");
    if (input.type == 'password') {
        input.setAttribute('type', 'text');
        $("#regPwdImg1").removeClass("small-eye-close1");
        $("#regPwdImg1").addClass("small-eye-open1");
    } else {
        input.setAttribute('type', 'password');
        $("#regPwdImg1").removeClass("small-eye-open1");
        $("#regPwdImg1").addClass("small-eye-close1");
    }
}

function isHide2() {
    var input2 = document.getElementById("renewLoginPwd");
    if (input2.type == 'password') {
        input2.setAttribute('type', 'text');
        $("#regPwdImg2").removeClass("small-eye-close2");
        $("#regPwdImg2").addClass("small-eye-open2");
    } else {
        input2.setAttribute('type', 'password');
        $("#regPwdImg2").removeClass("small-eye-open2");
        $("#regPwdImg2").addClass("small-eye-close2");
    }
}
